var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{staticClass:"tw-whitespace-nowrap",attrs:{"type":"text","size":"sm","disabled":_vm.isLocationFiltered || _vm.disabled == true},on:{"click":function($event){return _vm.assign(_vm.todoItem)}}},[_vm._v("\n  "+_vm._s(_vm.getUser(_vm.todoItem.assignedToUserId))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }